import store from "../../../../store";
import engi_doc_create from "./engi_doc_create.vue";

window.SB_DOC_CREATE =  new Vue({
    store,
    name : "ENGI_DOC_CREATE",
    el: '#engi_doc_create',

    data () {
        return {
            showModal: false,
        }
    },
    created () {

    },

    components : {
        engi_doc_create
    }
});
